import { Module, ActionContext } from 'vuex';
import { RootState } from '@/store';
import vueCookies from 'vue-cookies';
import { apiUserInfoGet, apiUserLogin } from '@/api/user';
import { IUserLoginReq, IUserLoginRes } from '@/api/user-types';

export interface UserState extends IUserLoginRes {
  [key: string]: any;
}

type Mutations<S = UserState> = {
  SET_USER(state: S, payload: object): void;
  SET_USER_STORE_ID(state: S, storeId: string): void;
  SET_TOKEN(state: S, token: string): void;
};

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<UserState, RootState>, 'commit'>;

const DEFAULT_USER_STATE = {
  token: '',
  customerId: 0,
  name: '',
  agentId: 0,
  binding: false,
  mobile: '',
  birthday: '',
  headUrl: '',
  gender: 0,
  storeId: '',
  whetherShow: true,
  isTourist: 1,
};

const state = (): UserState => ({ ...DEFAULT_USER_STATE });

const getters = {
  isGetUserInfo: (state: UserState): boolean => {
    return !!(state.customerId > 0) || !!state.isTourist;
  },
  getToken: (state: UserState): string => {
    return state.token || (vueCookies as any).get('token') || '';
  },
  getHeadUrl: (state: UserState): string => {
    return state.headUrl || require('@/assets/logo.png');
  },
};

const mutations = {
  SET_USER(state: UserState, plaload: object) {
    for (const [key, value] of Object.entries(plaload)) {
      state[key] = value;
    }
  },
  SET_USER_STORE_ID(state: UserState, storeId: string) {
    (vueCookies as any).set('storeId', storeId);
    state.storeId = storeId;
  },
  SET_TOKEN(state: UserState, token: string) {
    (vueCookies as any).set('token', token);
    state.token = token;
  },
};

const actions = {
  ACTION_LOGIN({ commit }: AugmentedActionContext, payload: IUserLoginReq) {
    return new Promise((resolve, reject) => {
      apiUserLogin(payload)
        .then((res) => {
          commit('SET_USER', res);
          commit('SET_TOKEN', res.token);
          commit('SET_USER_STORE_ID', res.storeId);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  ACTION_GET_USER_INFO({ commit }: AugmentedActionContext) {
    return apiUserInfoGet().then((res) => {
      commit('SET_USER', res);
      commit('SET_USER_STORE_ID', res.storeId);
    });
  },
  ACTION_SIGN_OUT({ commit }: AugmentedActionContext) {
    commit('SET_USER', { ...DEFAULT_USER_STATE });
    commit('SET_TOKEN', '');
    window.location.reload();
  },
};

const user: Module<UserState, RootState> = {
  namespaced: true,
  state: state(),
  getters,
  mutations,
  actions,
};

export default user;
